import React            from 'react';

class Base extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let { 
            max, 
            min, 
            value,
            onChange,
            attr,
        } = this.props;
        return(
            <input
                type            = "number"
                max             = { max }
                min             = { min }
                value           = { value }
                onChange        = { (e) => onChange(e) }
                className       = "marketkit-numeric-picker-wrapper-base"
                { ...attr }
            />
        )
    }
}

export default Base;